import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Typography from 'components/Typography'

import classes from './TextBase.module.scss'

/** @type {import("./types").default} */

const TextBase = ({ className, title, TitleLink, text, subtitle, htmlText, disableHeadingMargin = false }) => (
  <Grid className={clsx('TextBase', classes.root, className)}>
    {title && (
      <div className={clsx(classes.titleContainer, { [classes.marginDisabled]: disableHeadingMargin })}>
        <Typography component="h2" className={classes.title}>
          {title}
        </Typography>
        {TitleLink}
      </div>
    )}
    {subtitle && (
      <Typography component="h3" className={classes.subtitle}>
        {subtitle}
      </Typography>
    )}
    {text && (
      <Typography
        variant="p"
        className={classes.text}
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    )}
    {htmlText && (
      <span
        dangerouslySetInnerHTML={{
          __html: htmlText,
        }}
      />
    )}
  </Grid>
)

export default TextBase
